import {
  EnvironmentName,
  EnvironmentSpecificEnv,
} from './environment-specific.type';

export const environmentSpecificEnv: EnvironmentSpecificEnv = {
  environmentName: EnvironmentName.PROD,
  production: true,
  // using dev variables as this is not prod ready
  // dev,qa,and stage are using the prod flag right now
  // googleAnalytics: {
  //   id: 'UA-31203397-6',
  //   tag: 'GTM-K8TC847'
  // }
  googleAnalytics: {
    id: 'UA-31203397-3',
    tag: 'GTM-K8TC847',
  },
  recaptchaKey: '6Le_b2EqAAAAABhAfg2kO5KO_agfPqWu5pJn2yQ0',
  oktaClientId: '0oays0uhp0SgyHCNU0x7',
  oktaIssuer: 'https://login.alliancewebs.net/oauth2/ausmkot3jmgtQXrtZ0x7',
  splitKey: 'b77ltd7o3tso17vhll87db7vo5ljjnvd9eou',
  showOktaSignInButton: false,
  apiSubDomain: 'api',
};
